import { render } from "./ResearchSpaceButton.vue?vue&type=template&id=d16257d8&ts=true"
import script from "./ResearchSpaceButton.vue?vue&type=script&lang=ts"
export * from "./ResearchSpaceButton.vue?vue&type=script&lang=ts"

import "./ResearchSpaceButton.vue?vue&type=style&index=0&id=d16257d8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__